import * as actions from '../actions/newSolicitor';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import flattenConcurrently from 'xstream/extra/flattenConcurrently';

export function requestUnlockSolicitorUser(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.UNLOCK_SOLICITOR_USER)
		.map(action => ({
			url: BASE_URL + `api/users/solicitors/${action.payload.solicitorUserId}/unlock`,
			category: 'requestUnlockSolicitorUser',
			method: 'PATCH',
			type: 'application/json',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http post requests, it updates the redux store with the posted new solicitors
	let httpResponse$ = sources.HTTP
		.select('requestUnlockSolicitorUser')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.unlockSolicitorUserSuccess(response));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}

export function requestUnlockSolicitorUserFailed(sources) {
	let httpResponse$ = sources.HTTP
		.select('requestUnlockSolicitorUser')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200 )
		.map(response => actions.unlockSolicitorUserFailed(response));

	return {
		ACTION: httpResponse$
	}
}

export function postNewSolicitor(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_NEW_SOLICITOR)
		.map(action => ({
			url: BASE_URL + 'api/users/solicitors',
			category: 'postNewSolicitor',
			method: 'POST',
			type: 'application/json',
			send: {
				userToken: action.payload.userToken,
				lawsysId: action.payload.solicitor.lawsysAgentId,
				lawsysName: action.payload.solicitor.lawsysAgentName,
				forename: action.payload.solicitor.forename,
				surname: action.payload.solicitor.surname,
				ccEmail: action.payload.solicitor.ccEmailAddress,
				userName: action.payload.solicitor.userName,
				addressLine1: action.payload.solicitor.addressLine1,
				addressLine2: action.payload.solicitor.addressLine2,
				city: action.payload.solicitor.city,
				postcode: action.payload.solicitor.postcode,
				country: action.payload.solicitor.country,
				telephone1: action.payload.solicitor.telephoneNumber1,
				telephone1Description: action.payload.solicitor.telephoneNumber1Description,
				telephone2: action.payload.solicitor.telephoneNumber2,
				telephone2Description: action.payload.solicitor.telephoneNumber2Description,
				allowedToCreateApplications: action.payload.solicitor.allowedToCreateApplications,
                allowedToSeeAllFirmApplications: action.payload.solicitor.allowedToSeeAllFirmApplications,
				email: action.payload.solicitor.solicitorsEmailAddress,
				role: 'Solicitor'
			},
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http post requests, it updates the redux store with the posted new solicitors
	let httpResponse$ = sources.HTTP
		.select('postNewSolicitor')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 201)
		.map(response => actions.receivePostNewSolicitorResponse(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}

export function failedPostNewSolicitor(sources) {
	let httpResponse$ = sources.HTTP
		.select('postNewSolicitor')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status >= 400 )
		.map(response => actions.receiveBadResponsePostNewSolicitor(JSON.parse(response.response.text).message));

	return {
		ACTION: httpResponse$
	}
}

export function patchExistingSolicitor(sources) {
    // below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_PATCH_EXISTING_SOLICITOR)
        .map(action => ({
            url: BASE_URL + 'api/users/solicitors/' + action.payload.id,
            category: 'patchExistingSolicitorUser',
            method: 'PATCH',
            type: 'application/json',
            send: action.payload.newSolicitor,
            withCredentials: true
        }));

    //below httpResponse$ listens  for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the posted new solicitors
    let httpResponse$ = sources.HTTP
        .select('patchExistingSolicitorUser')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenConcurrently)
        .filter(response => response.status === 200)
        .map(response => actions.receivePatchExistingSolicitorResponse(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badResponsePatchSolicitor(sources) {
    let httpResponse$ = sources.HTTP
        .select('patchExistingSolicitorUser')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.receiveBadRequestPatchExistingSolicitor(response));

    return {
        ACTION: httpResponse$
    };
}

export function getSelectedSolicitorUser(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_SELECTED_SOLICITOR_USER )
        .map(action => ({
            url: BASE_URL + 'api/users/solicitors/' + action.payload,
            category: 'getSelectedSolicitorUser',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getSelectedSolicitorUser')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetSelectedSolicitorUser(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function postSendResetPasswordEmailToSolicitor(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR)
		.map(action => ({
			url: BASE_URL + 'api/users/AskResetPassword?userId='+action.payload.userId,
			category: 'postSendResetPasswordEmailToSolicitor',
			method: 'POST',
			type: 'application/json',
			send: {
				userId: action.payload.userId
			},
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http post requests, it updates the redux store with the posted new solicitors
	let httpResponse$ = sources.HTTP
		.select('postSendResetPasswordEmailToSolicitor')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveSendResetPasswordEmailToSolicitor("ok"));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};

}
